import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app.config.service';
import {XMLParser} from 'fast-xml-parser';
import { map, filter, switchMap, tap, catchError } from 'rxjs/operators';

import { of } from 'rxjs';
import { from, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SoapRequestService {
  public soapUserName:String;
  public soapPassword:String;
  public soapURL:any;
  public soapRequestURL:any;
  constructor(
    private http: HttpClient,
    private noAuthHttp: HttpClient,
    handler:HttpBackend,
    private configService: AppConfigService,
  ) {
    this.noAuthHttp = new HttpClient(handler);
    this.soapUserName = this.configService.get('soapUserName');
    this.soapPassword = this.configService.get('soapPassword');
    this.soapURL = this.configService.get('soapURL');
    this.soapRequestURL = this.configService.get('soapURL');
   }

   // This will convert XML response to JSON
  parseXML(data:any) {
    const parser = new XMLParser();
    return parser.parse(data);
  }

getSoapBody(serviceName:string, nameSpace:string, dataRequest:any) {
    const soapRequest = '<SOAP:Envelope xmlns:SOAP="http://schemas.xmlsoap.org/soap/envelope/">' +
                        '<SOAP:Body>' +
                        '<' + serviceName + ' xmlns="' + nameSpace + '">' +
                            dataRequest +
                        '</' + serviceName + '>' +
                        '</SOAP:Body>' +
                        '</SOAP:Envelope>';
  const parser = new DOMParser();
  parser.parseFromString(soapRequest, 'text/xml');
  return soapRequest;
  
}

getTokenGeneratorBody(){
  return '<SOAP:Envelope xmlns:SOAP="http://schemas.xmlsoap.org/soap/envelope/">'+
  '<SOAP:Header>'+
  '<wsse:Security xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd">'+
  '<wsse:UsernameToken>'+
  '<wsse:Username>'+this.soapUserName+'</wsse:Username>'+
  '<wsse:Password>'+this.soapPassword+'</wsse:Password>'+
  '</wsse:UsernameToken>'+
  '</wsse:Security>'+
  '</SOAP:Header>'+
  '<SOAP:Body>'+
  '<samlp:Request xmlns:samlp="urn:oasis:names:tc:SAML:1.0:protocol" MajorVersion="1" MinorVersion="1" IssueInstant="2009-04-01T10:23:11Z" RequestID="a997c83a8d-b5d7-b930-edba-02e37ab1765">'+
  '<samlp:AuthenticationQuery>'+
  '<saml:Subject xmlns:saml="urn:oasis:names:tc:SAML:1.0:assertion">'+
  '<saml:NameIdentifier Format="urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified">'+this.soapUserName+'</saml:NameIdentifier>'+
  '</saml:Subject>'+
  '</samlp:AuthenticationQuery>'+
  '</samlp:Request>'+
  '</SOAP:Body>'+
  '</SOAP:Envelope>'
}

public httpPost(data:any, header = { 'Content-Type': 'application/xml'}) {
  this.soapRequestURL = this.configService.get('soapURL');
  const paramData = this.getTokenGeneratorBody();
  
  return this.noAuthHttp.post(this.soapURL,paramData, { responseType: 'text' }).pipe(
    tap((res:any)=>this.soapRequestURL += '&SAMLart='+ this.parseXML(res)["SOAP:Envelope"]["SOAP:Body"]["samlp:Response"]["samlp:AssertionArtifact"]),
    switchMap(()=>this.noAuthHttp.post(this.soapRequestURL, data, { responseType: 'text', })),
    );
}

// public checkSapUser(userId){
//   const dataReq = '<ud_userid>'+userId+'</ud_userid>';
//   const soapBody = this.getSoapBody('CheckifSAPPasswordIsWorking','http://schemas.cordys.com/scsdatabasemetadata',dataReq)
//   return this.httpPost(soapBody).pipe(map(res=>{
//     res=this.parseXML(res);
//     return res["SOAP:Envelope"]["SOAP:Body"]["CheckifSAPPasswordIsWorkingResponse"]["tuple"]
//   }
//   ));
// }

}